const tabsInitialState = {
  tabKey: '1',
};

const currentTab = (state = tabsInitialState, action) => {
  switch (action.type) {
    case 'UPDATE_SET_AUTHORIZATION_TAB_KEY':
      return {
        ...state,
        tabKey: action.key,
      };

    default:
      return state;
  }
};

export default currentTab;

export const getTabKey = (state) => state.tabKey;
